import { map, cloneDeep } from 'lodash-es';
import * as types from './StepNavMenu.actionTypes';
import { StateEnum } from './StepNavMenu.enum';

/**
 * Set current menu item
 * @param {*} param0
 */
const setCurrent = ({ data, id }) => {
  try {
    const menu = map(data.menu, item => {
      const newItem = { ...item };

      if (item.state === StateEnum.CURRENT) {
        newItem.state = StateEnum.ENABLED;
      }
      if (item.id === id) {
        newItem.state = StateEnum.CURRENT;
      }

      return newItem;
    });

    return { menu, noDispatch: false };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setCurrent: ${e.stack}`);
  }
  return data;
};

/**
 * Reducer
 * @param {*} state
 * @param {*} action
 */
const reducer = (state, action) => {
  try {
    const { type } = action;
    let newState = cloneDeep(state);
    switch (type) {
      case types.SET_CURRENT: {
        const { id } = action;
        newState = setCurrent({ data: newState, id });
        break;
      }
      case types.UPDATE: {
        const { data } = action;
        newState = { menu: [...data.menu], noDispatch: true };
        break;
      }
      default:
        // eslint-disable-next-line no-console
        console.error(`Unexpected action`);
        return state;
    }

    return newState;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`reducer: ${e.stack}`);
  }
  return state;
};

export default reducer;
